import { render, staticRenderFns } from "./contacts-phone-selected.vue?vue&type=template&id=5d6bdd4e&scoped=true&"
import script from "./contacts-phone-selected.vue?vue&type=script&lang=js&"
export * from "./contacts-phone-selected.vue?vue&type=script&lang=js&"
import style0 from "./contacts-phone-selected.vue?vue&type=style&index=0&id=5d6bdd4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6bdd4e",
  null
  
)

/* custom blocks */
import block0 from "./contacts-phone-selected.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports